<template>
  <div id="stepOne">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <span class="sub-head"> {{ savingText }}</span><br>
      <b-overlay no-center :show="disabled" rounded="lg" :opacity="'0.9'" :blur="'5px'">
      <b-form-group class="applicationWizard">
        <b-tabs v-model="activeTab" vertical pills card @activate-tab="indexChanged">
          <b-tab title="Academic Information">
              <h2>Academic Information</h2>
              <p class="sub-head" style="text-transform: unset">Note: In order to be eligible, applicants must have been
                enrolled as full-time high
                school, undergraduate, or graduate students for at least one semester between June 2025 and September
                2026. Additionally, applicants must be 18 years old or older by 14 May 2026</p>
              <b-form-group>
                <b-form-group label="University / School / Institution Name" label-for="schoolName">
                  <b-form-input type="text" v-model="schoolName" id="schoolName" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="City" label-for="schoolCity">
                  <b-form-input type="text" v-model="schoolCity" id="schoolCity" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="State" label-for="schoolState">
                  <b-form-input type="text" v-model="schoolState" id="schoolState" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="Country" label-for="schoolCountry">
                  <b-form-select id="schoolCountry" v-model="schoolCountry" :options="countries" disabled>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <div class="row">
                    <div class="col">
                      <b-form-group label="Expected Graduation Month" label-for="expectedGraduationMonth">
                        <b-form-select id="expectedGraduationMonth" label="Month" v-model="expectedGraduationMonth"
                          :value="getExpectedGraduationMonth" :options="months" disabled></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group label="Expected Graduation Year" label-for="expectedGraduationYear">
                        <b-form-select id="expectedGraduationYear" label="Year" v-model="expectedGraduationYear"
                          :options="years" disabled>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </b-form-group>
                <b-form-group v-if="proofOfEnrollmentExists" label="Proof of Enrollment">
                  <div class="row">
                    <div v-if="proofOfEnrollment.type != 'application/pdf'" class="col">
                      <img  style="width:100%;height:100%;" :alt="proofOfEnrollment.name" :src="getDataURL" />
                    </div>
                    <div v-else class ="col">
                      <iframe style="width:100%;height:100%;" :alt="proofOfEnrollment.name" :src="getDataURL"></iframe>
                    </div>
                  </div>
                </b-form-group>
              </b-form-group>             
          </b-tab>
          <b-tab title="Professional References">
            <b-form-group style="flex-basis: 100%">
              <h2>Professional References</h2>
              <p>References will be contacted after applications close.</p>
              <b-tabs pills card class="reference-tab">
                <b-tab title="First Professional Reference">
                  <b-form-group>
                    <b-form-group label="Reference Type" label-for="firstReferenceType">
                      <b-form-select id="firstReferenceType" v-model="firstReferenceType" :options="referenceTypes" disabled>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Reference First Name" label-for="firstReferenceFirstName">
                      <b-form-input type="text" v-model="firstReferenceFirstName"
                        id="firstReferenceFirstName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Last Name" label-for="firstReferenceLastName">
                      <b-form-input type="text" v-model="firstReferenceLastName"
                        id="firstReferenceLastName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Email" label-for="firstReferenceEmail">
                      <b-form-input type="text" v-model="firstReferenceEmail" id="firstReferenceEmail" disabled></b-form-input>
                    </b-form-group>
                  </b-form-group>
                </b-tab>
                <b-tab title="Second Professional Reference">
                  <b-form-group>
                    <b-form-group label="Reference Type" label-for="secondReferenceType">
                      <b-form-select id="secondReferenceType" v-model="secondReferenceType" :options="referenceTypes" disabled>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Reference First Name" label-for="secondReferenceFirstName">
                      <b-form-input type="text" v-model="secondReferenceFirstName"
                        id="secondReferenceFirstName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Last Name" label-for="secondReferenceLastName">
                      <b-form-input type="text" v-model="secondReferenceLastName"
                        id="secondReferenceLastName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Email" label-for="secondReferenceEmail">
                      <b-form-input type="text" v-model="secondReferenceEmail" id="secondReferenceEmail" disabled></b-form-input>
                    </b-form-group>
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-form-group>
          </b-tab>
          <b-tab title="SIGGRAPH Experience">
            <div style="display:flex;flex-direction:column;height:100%;flex-basis: 100%">
                <b-form-group>
                  <h2>SIGGRAPH Experience</h2>
                  <b-form-group>
                    <b-form-checkbox v-model="haveAttended" disabled>I have participated in a
                      SIGGRAPH
                      North America Conference as an
                      attendee</b-form-checkbox>
                    <b-form-checkbox v-model="haveAttendedAsia" disabled>I have participated in a
                      SIGGRAPH Asia Conference as an
                      attendee</b-form-checkbox>
                    <b-form-checkbox v-model="haveVolunteered" disabled>I have participated in a
                      SIGGRAPH North America Conference as
                      a Student Volunteer</b-form-checkbox>
                    <b-form-checkbox v-model="haveVolunteeredAsia" disabled>I have participated in a
                      SIGGRAPH Asia Conference as a
                      Student Volunteer</b-form-checkbox>
                    <b-form-checkbox v-model="haveNotAttended"
                      disabled>This is my first
                      SIGGRAPH Conference</b-form-checkbox>
                  </b-form-group>
                  <b-form-group v-if="haveVolunteered"
                    label="Please select which years in which you have been a SIGGRAPH North America Student Volunteer."
                    label-for="yearsVolunteered">
                    <multiselect :options="previousSvYears" :value="getYearsVolunteered" :searchable="false"
                      :multiple="true" :close-on-select="false" :allow-empty="true" :hide-selected="true" disabled>
                      <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option
                            }}</span></span></template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group v-if="haveVolunteeredAsia"
                    label="Please select which years in which you have been a SIGGRAPH Asia Student Volunteer."
                    label-for="yearsVolunteered">
                    <multiselect :options="previousSvYears" :value="getYearsVolunteeredAsia" :searchable="false"
                      :multiple="true" :close-on-select="false" :allow-empty="true" :hide-selected="true">
                      <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option
                            }}</span></span></template>
                    </multiselect>
                  </b-form-group>
                </b-form-group>
            </div>
          </b-tab>
          <b-tab title="Student Volunteer Essays" lazy>
            <b-form-group>
              <h2>Student Volunteer Questions</h2>
              <h3>Question 1: Interest &amp Motivation</h3>
              <b-form-group label="We’d love to hear about the motivations that support your interest in becoming a student
                      volunteer. What excites you most about this opportunity, and what drives you to contribute to the
                      organization in this way? Share how your unique strengths, skills, and experiences would make you
                      an excellent fit for this role." label-for="essay1">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="essay1" v-model="essay1" rows="10"
                      max-rows="100" disabled></b-form-textarea>
                  </div>
                </div>
              </b-form-group>
              <h3>Question 2: Diverse Experiences</h3>
              <b-form-group label="SIGGRAPH is a vibrant and diverse community that brings together professionals, students, and
                      enthusiasts from all over the world. Tell about a time when you connected with people from a
                      background different from your own, and how the experience helped you grow or broaden your
                      perspective. Share any meaningful insights or lessons you took away, as well as how it may have
                      influenced your understanding, empathy, or approach to working with others." label-for="essay2">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="essay2" v-model="essay2" rows="10"
                      max-rows="100" disabled></b-form-textarea>
                  </div>
                </div>
              </b-form-group>
              <h3>Question 3: Conflict Resolution</h3>
              <b-form-group label="Conference environments can sometimes be unpredictable, and it’s not uncommon to face unexpected
                      or challenging situations. Please share about a time when you encountered a stressful or
                      surprising situation involving others, where you took it upon yourself to step in and resolve the
                      issue. What actions did you decide to take, and how did the situation ultimately play out?
                      Reflecting on this experience, what lessons did you gain, and how would you use those insights to
                      navigate similar challenges in the future?" label-for="essay3">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="essay3" v-model="essay3" rows="10"
                      max-rows="100" disabled></b-form-textarea>
                  </div>
                </div>
              </b-form-group>
            </b-form-group>
          </b-tab>
          <b-tab title="Team Leader Essays" lazy>
            <b-form-group>
              <h2>Become a Team Leader</h2>
                <p>Only SIGGRAPH Student Volunteers with at least 1 year of prior SV experience are eligible for Team
                  Leader positions. Team Leaders (TLs) are Student Volunteers (SVs) selected to serve as liaisons to
                  Venue and Program Chairs across the different areas of the conference.</p>
                <p>TLs have more responsibility and a more demanding workload than a regular SV. TLs serve in a
                  supervisory role as they help train SVs to perform different duties, and resolve more complex
                  attendee, contributor and volunteer questions and issues. TLs also volunteer approximately 60 hours
                  either in pre-conference shifts or during the SIGGRAPH week in addition to several pre-conference
                  training sessions.</p>
                <p>Please keep in mind the TL application process is very competitive. TL applicants not selected for
                  the role will still be considered for a position as SV.</p>
              <b-form-group>
                <b-form-checkbox id="teamLeader" v-model="teamLeader" disabled>
                  I would like to apply for a Team Leader position
                </b-form-checkbox>
              </b-form-group>
              <h3 v-if="teamLeader">Question 1: Interest &amp Motivation</h3>
              <b-form-group v-if="teamLeader"
                label="Being a team leader is a significant responsibility that not only involves working closely with the SVSC and other program chairs, but also fostering a positive, collaborative and encouraging environment for incoming SVs. What inspires you to step up and lead others, and what excites you about taking on this role within SIGGRAPH? "
                label-for="teamLeaderEssay1">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="teamLeaderEssay1"
                      v-model="teamLeaderEssay1" :rows="10" :max-rows="100" disabled/>
                  </div>
                </div>
              </b-form-group>
              <h3 v-if="teamLeader">Question 2: Leadership Experience</h3>
              <b-form-group v-if="teamLeader"
                label="How have your past experiences equipped you for this role? What skills have you honed—such as communication, problem-solving, or time management—that make you a strong fit for this position? Additionally, please share any leadership or mentorship experiences you’ve had, whether within SIGGRAPH or in other contexts, and how these have influenced your approach to supporting and guiding others."
                label-for="teamLeaderEssay2">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="teamLeaderEssay2"
                      v-model="teamLeaderEssay2" :rows="10" :max-rows="100" disabled />
                  </div>
                </div>
              </b-form-group>
            </b-form-group>
          </b-tab>
          <b-tab title="Financial Aid" lazy>
            <b-form-group>
              <h2>Financial Assistance</h2>
              <p>Travel assistance may be provided based on the Student Volunteer Program's availability of funds and on
                eligibility, which is determined on a case-by-case basis based solely on financial need. Assistance goes
                through a blind jury process. It is not based on nationality or country/location of residence, anyone
                can apply and everyone will be considered equally. Funds are limited and assistance is not guaranteed.
                Travel assistance, if awarded, will be communicated upon acceptance.</p>
              <b-form-group>
                <b-form-checkbox id="financialAid" v-model="financialAid" disabled>
                  I would like to apply for financial assistance
                </b-form-checkbox>
              </b-form-group>
              <b-form-group v-if="financialAid">
                <b-form-group label="We understand that attending SIGGRAPH can be a considerable financial investment. Please share
                      with us why financial assistance would be important for you to participate"
                  label-for="financialAidSummary">
                  <b-form-textarea id="financialAidSummary"
                    v-model="financialAidSummary" :rows="6" :max-rows="100" disabled/>
                </b-form-group>
                <b-form-group label="Please select any situations that apply to your request for financial assistance:"">
                <multiselect :options=" financialSituationOptions" :value="getFinancialSituation" :searchable="false"
                  :multiple="true" :close-on-select="false" track-by="value" label="text" :allow-empty="true"
                  :hide-selected="true" disabled>
                  <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text
                        }}</span></span></template>
                  </multiselect>
                </b-form-group>
                <b-form-group label="Please provide an itemized breakdown of your anticipated travel expenses in US dollars
                      (Typically assistance would include provisions for things like travel, lodging, food, conference
                      transport, etc)." label-for="financialAidExpenses">
                  <b-form-textarea id="financialAidExpenses" v-model="financialAidExpenses" :rows="6" :max-rows="100" disabled/>
                </b-form-group>
                <b-form-group label="Sum up your previous calculations into a total estimate in US dollars."
                  label-for="estimatedTravelCost">
                  <b-form-input type="text" v-model="estimatedTravelCost" id="estimatedTravelCost" disabled></b-form-input>
                </b-form-group>
                <b-form-group label="Primary Mode of Transportation to the Conference's City"
                  label-for="primaryTransport">
                  <b-form-select id="primaryTransport" v-model="primaryTransport" :options="primaryTransportList" disabled />
                </b-form-group>
                <b-form-group v-if="financialAidAndFlying"
                  label="If you will be flying, what is the 3-letter code for the airport you will be departing from? (Ex: IND for Indianapolis International Airport)"
                  label-for="airportCode">
                  <b-form-input type="text" v-model="airportCode" id="airportCode"
                    style="max-width:100px" disabled></b-form-input>
                </b-form-group>
                <b-form-group v-if="financialAidAndOtherTransport"
                  label="Please explain how you are planning to travel to the conference" label-for="otherTransport">
                  <b-form-input type="text" v-model="otherTransport" id="otherTransport" disabled></b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox id="fundedTravel" v-model="fundedTravel" disabled>
                    Funding for my travel will be fully or partially covered by outside sources (such as university
                    funding, etc.).
                  </b-form-checkbox>
                </b-form-group>
              </b-form-group>
            </b-form-group>
          </b-tab>
          <b-tab no-body title="Confirmation of Responsibilities">
            <b-card-body>
            <b-form-group>
              <h2>Confirmation of Responsibilities</h2>
              <div id="expectations" class="row">
                <div class="col">
                  <h4>Expectations</h4>
                  <p>Student Volunteers and Team Leaders are required to complete training provided by the Student
                    Volunteer Program after accepting a position, and will serve the conference during in-person shifts
                    at the Vancouver Convention Center at SIGGRAPH 2026 from 18 July - 23 July.</p>
                  <p> Student Volunteers will commit to volunteering about 25 hours to provide operational support for
                    SIGGRAPH 2026 in pre-conference shifts or the in-person conference. In exchange for their service
                    and enthusiasm, Student Volunteers receive the highest level of registration for the conference,
                    networking opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
                  <p>Team Leaders are expected to volunteer about 60 hours to provide operational and logistical support
                    for SIGGRAPH 2026 pre-conference shifts or the in-person conference. In exchange for their service
                    and enthusiasm, Team Leaders receive the highest level of registration for the conference,
                    networking opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
                  <p>Along with these expectations it’s also important to know:
                  <ul style="list-style-type:square; padding-left: 15px">
                    <li>Volunteers are not expected to depart the conference prior to 6PM (GMT-7) on 23 July 2026. Do
                      not plan on departing for home before then!.</li>
                    <li>No housing or accommodation will be provided to Team Leaders or Student Volunteers.
                      Opportunities to coordinate lodging with other student volunteers will be made available after
                      acceptance into the program.</li>
                    <li>More details on what is involved in being a Student Volunteer will be provided during the
                      upcoming months.</li>
                  </ul>
                  </p>
                </div>
              </div>
              <div id="ethics" class="row">
                <div class="col">
                  <h4>Ethics</h4>
                  <p>We hold ourselves and our Student Volunteers to the highest standards of professionalism,
                    integrity, and respect. It is essential that all individuals involved in the conference—including
                    attendees, volunteers, contributors, and contractors—are treated with courtesy and dignity. We are
                    committed to fostering an environment that is inclusive, welcoming, and conducive to productive
                    collaboration. Any breach of these expectations, whether through unprofessional conduct,
                    disrespectful behavior, threats, harassment, or failure to comply with the guidelines, will not be
                    tolerated. Such actions undermine the spirit of cooperation that defines our community and could
                    lead to removal from the program. Additionally, any violation may also result in the revocation of
                    access to the conference and its associated events.</p>
                  <p>Understanding also that through your interactions with contributors you may be privy to sensitive
                    or confidential information, by affirming your understanding of these guidelines you also verify
                    your
                    agreement to keep such information private.</p>
                </div>
              </div>
              <div id="benefits" class="row">
                <div class="col">
                  <h4>Benefits</h4>
                  <h5>Full Conference Registration</h5>
                  <p>Enjoy all of the latest and greatest this amazing conference has to offer! SIGGRAPH offers many
                    opportunities to explore the latest innovations when you are off-shift.</p>
                  <h5>Student Volunteer Special Sessions</h5>
                  <p>Hear top professionals in the industry and academia (some of them former Student Volunteers) speak
                    about tips, tricks, and job opportunities at exclusive “Student Volunteers-only” sessions before
                    SIGGRAPH 2026!</p>
                  <h5>Résumé and Reel Review Sessions</h5>
                  <p>Polish your reel and résumé, and get some professional feedback (virtually and in-person) to land
                    your dream job! Space is limited. This program is made possible by the SIGGRAPH Student Services
                    Committee (S3), and depends on the provided time of industry experts who are volunteers just like
                    you!</p>
                  <h5>Professional Development</h5>
                  <p>Expand your knowledge outside the classroom through leadership, mentoring, and diversity &
                    inclusion sessions tailored specially for student volunteers.</p>
                  <h5>Networking</h5>
                  <p>Participate in the many events and get-togethers we will organize prior to and during the
                    conference. Meet students from all over the globe who share your passion for computer graphics and
                    interactive techniques!</p>
                </div>
              </div>
              <div id="deadlines" class="row">
                <div class="col">
                  <h4>Deadlines (submissions will close at 22:00 UTC/GMT)</h4>
                  <h6 class="sub-head">{{ formattedDate(applicationTlEndDate) }}: Team Leader Applications</h6>
                  <p>Team Leader application results will be sent in mid-February 2026. You will receive an email
                    notification at the address you provided in your application. Applicants who are not accepted as
                    Team Leaders will still be considered for Student Volunteer positions.</p>
                  <h6 class="sub-head">{{ formattedDate(applicationEndDate) }} : Student Volunteer Applications</h6>
                  <p>Student Volunteer application results will be sent in late April 2026. You will receive an email
                    notification at the address you provided in your application, and be required to confirm your
                    position by late April 2026, or potentially forfeit your spot in the program. If you applied for
                    financial aid, you will be notified of any funds awarded with the results of your application. These
                    funds will not be released to you until after the conference.</p>
                </div>
              </div>
              <h4>Terms and Responsibilities Agreement</h4>
              <p>Please take a moment to carefully review the <a
                  href="https://s2026.siggraph.org/program/student-volunteers/" target="_blank">Student Volunteer
                  Eligibility Requirements and
                  Responsibilities</a>. Once you have read them, confirm that you meet the criteria, are eligible to
                participate, and are willing to comply with the responsibilities described.</p>
              <b-form-group>
                <b-form-checkbox id="acceptedTerms" v-model="acceptedTerms" disabled>
                  I have read these requirements and affirm my eligibility and willingness to participate in the Student
                  Volunteer Program
                </b-form-checkbox>
              </b-form-group>
              <h4>Media Release Agreement</h4>
              <p>I grant permission for ACM/SIGGRAPH and its agents or employees to take and use photographs and/or
                video taken of me for use in promotional and educational electronic, video, and print materials for the
                SIGGRAPH organization. Furthermore, I authorize the use of my name, likeness, and voice for all SIGGRAPH
                Conference and organization promotion deemed appropriate and necessary by ACM/SIGGRAPH.</p>
              <p>I hereby waive any right of privacy and the right to inspect or approve the finished photographs or
                video that may be used in conjunction with such use now or in the future, whether that use is known to
                me or unknown. I also waive any right to royalties or other compensation arising from or related to the
                use of said photographs/video created for this purpose.</p>
              <p>I have read this release before accepting the conditions below, and I fully understand the contents,
                meaning, and impact of this release. I understand that I am free to address any specific questions
                regarding this release by submitting those questions in writing prior to signing, and I agree that my
                failure to do so will be interpreted as a free and knowledgeable acceptance of the terms of this
                release.</p>
              <b-form-group class="mt-4">
                <b-form-checkbox id="acceptedMediaRelease" v-model="acceptedMediaRelease" disabled>I Agree</b-form-checkbox>
              </b-form-group>
              <h4>Privacy Policy Agreement</h4>
              <p>I have read and accept the <a href="https://www.acm.org/about-acm/privacy-policy">ACM Privacy
                  Policy</a></p>
              <b-form-group class="mt-4">
                <b-form-checkbox id="acceptedPrivacy" v-model="acceptedPrivacy" disabled>
                  I Agree
                </b-form-checkbox>
              </b-form-group>
              <h4>Additional Comments</h4>
              <b-form-group
                label="We look forward to reviewing your application! Is there anything else you would like to share?"
                label-for="otherComments">
                <b-form-textarea id="otherComments" v-model="otherComments"
                  :rows="6" :max-rows="100"  disabled/>
              </b-form-group>
            </b-form-group>
          </b-card-body>
          </b-tab>
        </b-tabs>
        <b-card-footer>
        <div class="row">
          <div v-if="activeTab !== 0" class="col">
            <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-med float-left"
              @click="previousStep">
              <div>Previous Step</div>
            </button>
          </div>
          <div class="col">
            <button v-if="activeTab !== 6" type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
              @click="nextStep">
              <div>Next Step</div>
            </button>
          </div>
        </div>
      </b-card-footer>
      </b-form-group>
    </b-overlay>
    </b-form>
  </div>
</template>

<script>
import { countries, months, years, previousSvYears, referenceTypes, primaryTransportList, financialSituationOptions } from '@/util/SelectLists'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Multiselect from 'vue-multiselect'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'ViewApplication',
  data () {
    return {
      countries: countries,
      months: months,
      years: years,
      previousSvYears: previousSvYears,
      referenceTypes: referenceTypes,
      primaryTransportList: primaryTransportList,
      financialSituationOptions: financialSituationOptions,
      disabled: false,
      savingText: '',
      activeTab: -1
    }
  },
  computed: {
    ...generateVuexSetters([
      'schoolName',
      'schoolCity',
      'schoolState',
      'schoolCountry',
      'expectedGraduationMonth',
      'expectedGraduationYear',
      'haveNotAttended',
      'haveAttended',
      'haveVolunteered',
      'yearsVolunteered',
      'haveAttendedAsia',
      'haveVolunteeredAsia',
      'yearsVolunteeredAsia',
      'firstReferenceType',
      'firstReferenceFirstName',
      'firstReferenceLastName',
      'firstReferenceEmail',
      'secondReferenceType',
      'secondReferenceFirstName',
      'secondReferenceLastName',
      'secondReferenceEmail',
      'essay1',
      'essay2',
      'essay3',
      'teamLeaderEssay1',
      'teamLeaderEssay2',
      'otherComments',
      'financialAidSummary',
      'primaryTransport',
      'airportCode',
      'otherTransport',
      'financialAidExpenses',
      'financialSituation',
      'estimatedTravelCost',
      'fundedTravel',
      'acceptedTerms',
      'acceptedMediaRelease',
      'acceptedPrivacy'
    ]),
    proofOfEnrollment: {
      get () {
        return this.$store.state.application.data.proofOfEnrollment
      }
    },
    teamLeader: {
      get () {
        return this.$store.state.application.teamLeader
      },
      set (value) {
        this.$store.commit('application/updateTeamLeader', value)
      }
    },
    financialAid: {
      get () {
        return this.$store.state.application.financialAid
      },
      set (value) {
        this.$store.commit('application/updateFinancialAid', value)
      }
    },
    ...mapGetters('application', [
      'proofOfEnrollmentExists',
      'proofOfEnrollmentFileSize',
      'getDataURL',
      'getExpectedGraduationMonth',
      'getExpectedGraduationYear',
      'getYearsVolunteered',
      'getYearsVolunteeredAsia',
      'financialAidAndFlying',
      'financialAidAndOtherTransport',
      'getFinancialSituation'
    ]),
    ...mapGetters(['pastTLAppDeadline']),
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapState(['applicationTlEndDate', 'applicationEndDate'])
  },
  methods: {
    formattedDate: function (date) {
      return moment(date).tz('UTC').format('D MMMM YYYY')
    },
    updateExpectedGraduationMonth (value) {
      console.log(value)
      this.$store.commit('application/updateField', { name: 'expectedGraduationMonth', value: value })
    },
    updateExpectedGraduationYear (value) {
      this.$store.commit('application/updateField', { name: 'expectedGraduationYear', value: value })
    },
    nextStep (e) {
      e.preventDefault()
      this.activeTab++
    },
    indexChanged (newIndex, prevIndex, e) {
      if (newIndex !== this.$store.state.application.step) {
        window.scrollTo(0, 100)
        this.$store.commit('application/updateStep', newIndex)
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.activeTab--
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        this.savingText = 'Submitted On: ' + moment(this.$store.state.application.updatedAt).local().format('LLL')
      })
      this.activeTab = 0
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    multiselect: Multiselect
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/FileUploader.scss';
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
</style>



// WEBPACK FOOTER //
// src/components/application/ViewCompleteApplication.vue